/*
 * Psydeck desktop search (snippets/psydeck-desktop-search.liquid).
 * The dropdown under the field opens on focus with popular searches and the
 * newest sets, then live results (assets/psydeck-menu-search.js). Arrow keys
 * move through the dropdown's links, Escape closes it, Enter opens the search page.
 */
(function () {
  // The document listener from the last setup; a Theme Editor re-render removes it.
  var globalListeners = null;

  function initSearch() {
    var root = document.querySelector('[data-psy-ds]');
    if (!root || root.dataset.psyDsReady || !window.PsydeckMenuSearch) return;
    root.dataset.psyDsReady = '1';
    if (globalListeners) globalListeners.abort();
    globalListeners = window.AbortController ? new AbortController() : null;

    var input = root.querySelector('[data-psy-ds-q]');
    var drop = root.querySelector('[data-psy-ds-drop]');
    var empty = root.querySelector('[data-psy-ds-empty]');
    var clear = root.querySelector('[data-psy-ds-clear]');
    var emptyHasContent = empty.children.length > 0;

    var search = window.PsydeckMenuSearch.attach({
      root: root,
      input: input,
      empty: empty,
      results: root.querySelector('[data-psy-ds-results]'),
      all: root.querySelector('[data-psy-ds-all]'),
      clear: clear,
      prefix: 'psy-ds',
      onRender: function () {
        if (dismissed) return;
        if (document.activeElement === input || root.contains(document.activeElement)) show();
      }
    });

    // After Escape the dropdown stays closed until the next keystroke, focus or click.
    var dismissed = false;

    function show() {
      // Nothing to show before typing when the menu has no suggestions or sets.
      if (!input.value.trim() && !emptyHasContent) return hide();
      if (drop.hidden) drop.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      drop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
    }
    function hide() {
      drop.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
    }

    function reopen() { dismissed = false; show(); }
    input.addEventListener('focus', reopen);
    input.addEventListener('click', reopen);
    input.addEventListener('input', function () { dismissed = false; });

    root.addEventListener('click', function (e) {
      var term = e.target.closest('[data-psy-ds-term]');
      if (term) {
        e.preventDefault();
        input.value = term.dataset.psyDsTerm;
        input.focus();
        return search.run(true);
      }
      if (e.target.closest('[data-psy-ds-clear]')) {
        input.value = '';
        input.focus();
        search.run();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // type=search clears its value on Escape and fires input, which would
        // re-render and reopen the dropdown: handle Escape here instead.
        e.preventDefault();
        dismissed = true;
        if (!drop.hidden) { hide(); input.focus(); }
        else if (input.value) { input.value = ''; search.run(); }
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (drop.hidden) return;
      var links = Array.prototype.filter.call(drop.querySelectorAll('a[href]'), function (a) { return a.offsetParent !== null; });
      if (!links.length) return;
      var i = links.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (links[i + 1] || links[0]).focus();
      else if (i <= 0) input.focus();
      else links[i - 1].focus();
    });

    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !root.contains(e.relatedTarget)) hide();
    });
    document.addEventListener('pointerdown', function (e) {
      if (!root.contains(e.target)) hide();
    }, globalListeners ? { signal: globalListeners.signal } : false);
  }

  initSearch();
  // Theme Editor: the header section re-renders with fresh markup; set it up again.
  document.addEventListener('shopify:section:load', initSearch);
})();
